import CryptoJS from "./crypto.js";

export default function(password) {
  return CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex);
}
